import Layout from "@/components/common/Layout/Layout";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaUserCircle } from "react-icons/fa";
import { setUserInfo } from "@/Redux/features/UserProfileInfo/UserProfileInfoSlice";
import { FcApproval, FcLike } from "react-icons/fc";
import {
  useFollowPodcastMutation,
  useGetMyListenPodcastQuery,
} from "@/Redux/features/podcast/podcastApi";
import { createGroupWithFollowers } from "@/Redux/features/chat/chatSlice";
import { selectCurrentToken } from "@/Redux/features/auth/authSlice";
import { useRouter } from "next/navigation";
import { useMyInfoQuery } from "@/Redux/features/UserProfileInfo/UserProfileInfoApi";
import toast from "react-hot-toast";
import Loading from "@/components/common/loading";
import { useGetAllCategoryQuery } from "@/Redux/features/category/categoryApi";
import { format } from "date-fns";

const Profile = () => {
  const router = useRouter();
  // const [user, setUser] = useState({});
  const [flw_podcast, setFlw_podcast] = useState("Follow");
  const [filteredPodcasts, setFilteredPodcasts] = useState([]);
  const [isPodcastsShow, setIsPodcastsShow] = useState(false);
  const dispatch = useDispatch();
  const currentToken = useSelector(selectCurrentToken);

  const {
    data: profileInfo,
    isLoading: myInfoLoading,
    isFetching: myInfoFetching,
    refetch: profileInfoRefetch,
  } = useMyInfoQuery(undefined, {
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  const {
    data: categories,
    isLoading: categoryLoading,
    isFetching: categoryFetching,
    refetch: categoryRefetch,
  } = useGetAllCategoryQuery();

  const {
    data: listenPodcast,
    isLoading: listenPodcastLoading,
    refetch: podcastRefetch,
  } = useGetMyListenPodcastQuery();

  try {
    dispatch(setUserInfo({ userInfo: profileInfo }));
  } catch (error) {
    console.log(error);
  }

  const handleCreateChatWithFollowers = () => {
    dispatch(createGroupWithFollowers({ token: currentToken, router }));
  };

  //===========> check the podcast already followed and liked or not ==============================
  useEffect(() => {
    if (profileInfo) {
      console.log(profileInfo, "profileInfo");
      profileInfo?.user?.podcastInteractions &&
        profileInfo?.user?.podcastInteractions?.forEach((element) => {
          listenPodcast?.podcasts?.forEach((podcast) => {
            if (element?.podcastId === podcast?._id) {
              if (element?.action === "follow") {
                setFlw_podcast("Followed");
              }
            }
          });

          profileInfoRefetch();
        });
    }
  }, [profileInfo, listenPodcast, profileInfoRefetch]);

  //============================== handle follow and Unfollow podcast ================================
  const [followPodcast] = useFollowPodcastMutation();
  const handleFollowOrUnFollow = async (podcastId) => {
    const isFollowing = profileInfo?.user?.podcastInteractions?.some(
      (element) =>
        element?.podcastId === podcastId && element?.action === "follow"
    );

    // Send "follow" if not following, otherwise send "unfollow"
    const action = isFollowing ? "unfollow" : "follow";

    const data = {
      podcastId: podcastId,
      action,
    };

    console.log(data);
    try {
      const res = await followPodcast(data);

      if (res?.data?.success) {
        toast.success(res?.data?.message);
        podcastRefetch();
        profileInfoRefetch();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFilterPodcasts = (cat) => {
    const filtered = profileInfo?.user?.podcasts?.filter((podcast) => {
      return (
        podcast?.categories?.[0]?.category.toLowerCase() === cat.toLowerCase()
      );
    });
    setFilteredPodcasts(filtered);
    setIsPodcastsShow(true);
  };

  return (
    <Layout pageTitle={"Podcast | Profile"}>
      <section className="max-w-screen-xl  mx-auto px-5 dark:bg-black dark:text-white">
        {myInfoLoading ||
          myInfoFetching ||
          listenPodcastLoading ||
          (listenPodcastLoading && <Loading />)}
        <section className="md:grid md:grid-cols-12 gap-2 py-10">
          <div className="md:col-span-3 mb-5">
            {profileInfo?.user?.picture ? (
              <p className=" rounded-full md:w-40 md:h-40 lg:w-60 lg:h-60 md:bg-gradient-to-l  from-blue-500 to-[#3ae9da]">
                <Image
                  className="border-2 md:border-none border-blue-600  md:p-1 w-40 h-40 mx-auto lg:w-60 lg:h-60 rounded-full"
                  src={`${
                    profileInfo?.user?.picture?.path
                      ? profileInfo?.user?.picture?.path
                      : "/"
                  }`}
                  alt="logo"
                  priority
                  width={400}
                  height={300}
                />
              </p>
            ) : (
              <p>
                <FaUserCircle className="text-9xl text-red-600 mx-auto" />
              </p>
            )}
          </div>

          <div className="md:col-span-9">
            <section className="">
              <section className="md:flex gap-3 justify-between mt-9">
                <div className="flex gap-3 my-2">
                  <p className="my-auto md:text-2xl font-bold">
                    {profileInfo?.user?.firstName} {profileInfo?.user?.lastName}
                  </p>
                  <FcApproval className="my-auto text-lg" />
                  <p className="my-auto font-thin">
                    @{profileInfo?.user?.username}
                  </p>
                </div>
                <div className="flex gap-2">
                  {profileInfo?.user?.role === "user" ? (
                    <button
                      className="w-full  p-2 bg-blue-600 text-white rounded-b mt-3"
                      onClick={() => router.push(`/sub-details`)}
                    >
                      Apply for Author
                    </button>
                  ) : (profileInfo?.user?.role === "author" ||
                      profileInfo?.user?.role === "admin") &&
                    !profileInfo?.user?.chats?.some(
                      (chat) =>
                        chat?.createdBy === profileInfo?.user?._id &&
                        chat?.isGroup
                    ) ? (
                    <button
                      className="w-full p-2 bg-blue-600 text-white rounded-b mt-3"
                      onClick={handleCreateChatWithFollowers}
                    >
                      Create Chat
                    </button>
                  ) : profileInfo?.user?.role === "author" ? (
                    <button
                      className="w-full p-2 bg-blue-600 text-white rounded-b mt-3"
                      onClick={() => router.push(`/inbox`)}
                    >
                      Chat With Followers
                    </button>
                  ) : (
                    <></>
                  )}
                </div>
              </section>

              {profileInfo?.user?.role === "author" ||
              profileInfo?.user?.role === "admin" ? (
                <section className="flex gap-10 text-sm font-semibold">
                  <div className=" text-center">
                    <p>Followers</p>
                    <p>{profileInfo?.user?.followersCount}</p>
                  </div>
                  <div className=" text-center">
                    <p>Following</p>
                    <p>{profileInfo?.user?.followingCount}</p>
                  </div>
                  <div className=" text-center">
                    <p>Podcast</p>
                    <p>{profileInfo?.user?.podcastsCount}</p>
                  </div>
                  <div className=" text-center">
                    <p>Likes</p>
                    <p>{profileInfo?.user?.totalLikes}</p>
                  </div>
                </section>
              ) : (
                <></>
              )}

              <section className="mt-9 mb-16 p-2 bg-gray-100 dark:bg-slate-700 rounded">
                <p className="text-sm font-bold">About</p>
                <p className="my-2">{profileInfo?.user?.bio}</p>
              </section>
            </section>

            {/* <section className="my-10">
              <p className="text-base font-bold mb-8">Listen Podcasts</p>

              <section className="">
                {listenPodcast?.podcasts &&
                  listenPodcast?.podcasts?.map((podcast, i) => (
                    <div
                      key={i}
                      className="border w-full md:flex gap-4 justify-between my-5 p-2  bg-blue-50 dark:bg-gray-900 border-blue-600 rounded-xl"
                    >
                      <div className="md:w-3/4 md:flex gap-4">
                        <Image
                          className="w-full h-72 md:w-1/3 md:h-36 lg:w-1/3 lg:h-44   lg:mx-0  rounded-xl"
                          src={`${podcast?.picture?.path
                            ? podcast?.picture?.path
                            : "/"
                            }`}
                          width={300}
                          height={100}
                          priority
                          alt="logo"
                        />

                        <div className="my-5 md:my-auto">
                          <p className="text-2xl font-bold mb-3">
                            {podcast?.title}
                          </p>
                          <div className="lg:flex gap-2 justify-around items-center">
                            <div className="flex gap-2 my-1">
                              <p className="text-base  bg-blue-400 rounded-lg px-4">
                                {podcast?.categories[0]?.category}
                              </p>
                              <div className="flex gap-2 bg-gray-600 rounded-lg px-3">
                                <FcLike className="my-auto" />
                                <p className="my-auto text-white">
                                  {podcast?.totalLike}
                                </p>
                              </div>
                              <div className="flex gap-2 bg-gray-600 rounded-lg px-3">
                                <FaUsers className="my-auto text-white" />
                                <p className="my-auto text-white">
                                  {podcast?.totalFollowers}
                                </p>
                              </div>
                            </div>
                            <p className="text-base">
                              {podcast?.createdBy?.firstName}{" "}
                              {podcast?.createdBy?.lastName}
                            </p>
                          </div>
                          <p className="font-semibold">
                            Total Episodes: {podcast?.episodes?.length}
                          </p>
                        </div>
                      </div>

                      <div className="mt-5">
                        <button
                          onClick={() => handleFollowOrUnFollow(podcast?._id)}
                          className="cursor-pointer px-3 py-2 font-bold text-white bg-gradient-to-t  from-blue-400 to-[#5E1CE4] rounded-3xl"
                        >
                          {profileInfo?.user?.podcastInteractions?.some(
                            (element) =>
                              element?.podcastId === podcast?._id &&
                              element?.action === "follow"
                          )
                            ? "Followed"
                            : "Follow"}
                        </button>

                        <div className="flex justify-center md:mt-8">
                          <button
                            onClick={() =>
                              router.push(`/view-podcast?id=${podcast?._id}`)
                            }
                            className="px-2  rounded-full bg-gradient-to-t  from-blue-400 to-[#5E1CE4] text-center"
                          >
                            <svg
                              className="ml-3"
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="50"
                              viewBox="0 0 25 50"
                              fill="none"
                            >
                              <g clipPath="url(#clip0_2_11564)">
                                <path
                                  d="M13.3164 24.2031C13.5508 24.3906 13.6914 24.6719 13.6914 25C13.6914 25.3281 13.5508 25.6094 13.3164 25.7969L2.34766 34.4219C2.16016 34.5625 1.92578 34.6562 1.69141 34.6562C1.55078 34.6562 1.41016 34.6094 1.26953 34.5625C0.894531 34.375 0.660156 34 0.660156 33.625V16.375C0.660156 16 0.894531 15.625 1.26953 15.4375C1.59766 15.2969 2.01953 15.3438 2.34766 15.5781L13.3164 24.2031ZM2.72266 31.4688L10.9727 25L2.72266 18.5312V31.4688Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_2_11564">
                                  <rect
                                    width="24"
                                    height="50"
                                    fill="white"
                                    transform="matrix(1 0 0 -1 0.660156 50)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </section>
            </section> */}

            {(profileInfo?.user?.role === "author" ||
              profileInfo?.user?.role === "admin") && (
              <section className="my-10">
                <p className="text-lg font-bold mb-5">Categories</p>
                <section className="grid grid-cols-5 gap-5 items-center">
                  {categories?.category?.map((cat, index) => (
                    <div
                      key={index}
                      className="py-2 px-4 border border-blue-800 bg-blue-300 rounded-md text-center font-semibold text-base cursor-pointer transition-all duration-700 ease-in-out text-blue-800 hover:text-blue-700 hover:bg-blue-400 uppercase"
                      onClick={() => handleFilterPodcasts(cat?.category)}
                    >
                      {cat?.category}
                    </div>
                  ))}
                </section>

                {filteredPodcasts?.length > 0 && isPodcastsShow && (
                  <section>
                    <h3 className="mt-4 font-semibold">
                      Podcasts related to{" "}
                      {filteredPodcasts?.[0]?.categories?.[0]?.category}
                    </h3>
                    {filteredPodcasts?.map((podcast, index) => {
                      return (
                        <div key={index}>
                          <div className="md:flex gap-4 justify-between items-center my-5 p-2 px-5 bg-gray-100 dark:bg-black rounded-lg">
                            <div className="md:flex gap-4">
                              <img
                                className="md:w-44 md:h-44 mx-auto lg:mx-0  rounded-xl"
                                src={podcast?.picture?.path}
                                alt="logo"
                              />

                              <div className="my-5 md:my-auto">
                                <p className="text-2xl font-bold mb-3">
                                  {podcast?.title}
                                </p>
                                <div className="lg:flex gap-1 justify-around">
                                  <div className="flex gap-2 my-1">
                                    <p className="text-base  bg-blue-400 rounded-lg px-4">
                                      {podcast?.categories?.[0]?.category}
                                    </p>
                                    <div className="flex gap-2 bg-gray-600 rounded-lg px-3">
                                      <FcLike className="my-auto" />
                                      <p className="my-auto text-white">
                                        {podcast?.totalLike}
                                      </p>
                                    </div>
                                  </div>
                                  <p className="text-base">
                                    {podcast?.createdBy?.firstName}
                                  </p>
                                  <p className="text-base font-bold">
                                    {format(podcast?.createdAt, "MMMM d, yyyy")}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div>
                              <div className="flex justify-center items-center">
                                <a href={`/view-podcast?id=${podcast?._id}`}>
                                  <button className="px-2  rounded-full bg-gradient-to-t  from-blue-400 to-[#5E1CE4] text-center">
                                    <svg
                                      className="ml-3"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="25"
                                      height="50"
                                      viewBox="0 0 25 50"
                                      fill="none"
                                    >
                                      <g clipPath="url(#clip0_2_11564)">
                                        <path
                                          d="M13.3164 24.2031C13.5508 24.3906 13.6914 24.6719 13.6914 25C13.6914 25.3281 13.5508 25.6094 13.3164 25.7969L2.34766 34.4219C2.16016 34.5625 1.92578 34.6562 1.69141 34.6562C1.55078 34.6562 1.41016 34.6094 1.26953 34.5625C0.894531 34.375 0.660156 34 0.660156 33.625V16.375C0.660156 16 0.894531 15.625 1.26953 15.4375C1.59766 15.2969 2.01953 15.3438 2.34766 15.5781L13.3164 24.2031ZM2.72266 31.4688L10.9727 25L2.72266 18.5312V31.4688Z"
                                          fill="white"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_2_11564">
                                          <rect
                                            width="24"
                                            height="50"
                                            fill="white"
                                            transform="matrix(1 0 0 -1 0.660156 50)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </button>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </section>
                )}
                {!filteredPodcasts?.length && isPodcastsShow && (
                  <div className="mt-7 font-semibold text-lg text-center">
                    No Podcast Found Related To This Category
                  </div>
                )}
              </section>
            )}
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Profile;
